/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsjoinerssplitlabel3Inputs */

const en_statsjoinerssplitlabel3 = /** @type {(inputs: Statsjoinerssplitlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split by account and web guest`)
};

const de_statsjoinerssplitlabel3 = /** @type {(inputs: Statsjoinerssplitlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufteilung nach Konto und Web-Gast`)
};

/**
* | output |
* | --- |
* | "Split by account and web guest" |
*
* @param {Statsjoinerssplitlabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsjoinerssplitlabel3 = /** @type {((inputs?: Statsjoinerssplitlabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsjoinerssplitlabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsjoinerssplitlabel3(inputs)
	return de_statsjoinerssplitlabel3(inputs)
});
export { statsjoinerssplitlabel3 as "statsJoinersSplitLabel" }